import React from "react";
import { Link } from "react-router-dom";
import "./menuLeftProv.css";
//
import logoAmebo from "../../../assets/logo/logo2.png";
//
import { MdOutlineAttachMoney } from "react-icons/md";
import {
  FaUserAlt,
  FaClipboardList,
  FaFileSignature,
  FaHandsHelping,
} from "react-icons/fa";
import { FaDeleteLeft } from "react-icons/fa6";
import { GoFileSubmodule } from "react-icons/go";
import { RiLockPasswordFill } from "react-icons/ri";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

const MenuProvComercializador = ({ viewSee }) => {
  const navigate = useNavigate();

  const changeviewprov = (e, page) => {
    e.preventDefault();
    viewSee(page);
  };

  const handleLogout = () => {
    Cookies.remove("token");
    Cookies.remove("adminType");
    sessionStorage.removeItem("Data");
    navigate("/");
  };

  return (
    <div className="allmenuleft">
      <div className="boxlogoprov">
        <img className="logomenuleftprov" src={logoAmebo} alt="logo" />
      </div>
      <div className="boxallbuttonprov">
        <Link to="/portal-comercializadores/mis-ventas">
          <div className="boxbuttonprov">
            <p className="letterbuttonprov">
              <MdOutlineAttachMoney className="iconprov" />
              Mis ventas
            </p>
          </div>
        </Link>
        <div
          className="boxbuttonprov"
          onClick={(e) => changeviewprov(e, "Perfil")}
        >
          <p className="letterbuttonprov">
            <FaUserAlt className="iconprov" />
            Perfil
          </p>
        </div>
        <div
          className="boxbuttonprov"
          onClick={(e) => changeviewprov(e, "Convenio")}
        >
          <p className="letterbuttonprov">
            <FaFileSignature className="iconprov" />
            Convenio con entidad
          </p>
        </div>
        <div className="flexbuttonsphone">
          <Link to="/portal-comercializadores/mis-facturas">
            <div className="boxbuttonprov">
              <p className="letterbuttonprov">
                <FaClipboardList className="iconprov" />
                Mis facturas
              </p>
            </div>
          </Link>
        </div>
        <div
          className="boxbuttonprov"
          onClick={(e) => changeviewprov(e, "Factura")}
        >
          <p className="letterbuttonprov">
            <FaHandsHelping className="iconprov" />
            Subir factura
          </p>
        </div>
        <div
          className="boxbuttonprov"
          onClick={(e) => changeviewprov(e, "Documentacion")}
        >
          <p className="letterbuttonprov">
            <GoFileSubmodule className="iconprov" />
            Mi documentacion
          </p>
        </div>
        <div
          className="boxbuttonprov"
          onClick={(e) => changeviewprov(e, "Contraseña")}
        >
          <p className="letterbuttonprov">
            <RiLockPasswordFill className="iconprov" />
            Cambiar contraseña
          </p>
        </div>
        <div className="boxbuttonprov" onClick={handleLogout}>
          <p className="letterbuttonprov">
            <FaDeleteLeft className="iconprov" />
            Salir
          </p>
        </div>
      </div>
    </div>
  );
};

export default MenuProvComercializador;
